import firebase from "firebase/app";
import firebaseConfig from "./firebaseConfig";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import "firebase/messaging";

// Initialize Firebase
export const firebaseRef = firebase.initializeApp(firebaseConfig); //this is to initilize firebase
export const db = firebase.firestore();
export const storage = firebase.storage();
export const storageRef = firebase.storage().ref();
const messaging = firebaseRef.messaging();
messaging.usePublicVapidKey(
  // Project Settings => Cloud Messaging => Web Push certificates
  "BHEp5DzHIpKnHOx5dLtSL4b3OlABRn7P_mgBnchWgNLCliIT_pj0jkSi90E-qoPXfGhb9EIS8xUA0_ZSAiqb1iI"
);
export { messaging };
